<template>
<div>
    <Breadcrumbs main="Admin" submain="System" title="Package" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New Package</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="package_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(title)="row">
                                        <div v-if="row.item.title">
                                            <h7 style="font-size: 15px; font-weight: 500;">{{ row.item.title }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(type)="row">
                                        <div v-if="row.item.type">
                                            <b-badge variant="primary" class="badge-pill" style="text-transform: capitalize;" v-if="row.item.type == 'monthly'">{{ row.item.type }}</b-badge>
                                            <b-badge variant="secondary" class="badge-pill" style="text-transform: capitalize;" v-if="row.item.type == 'yearly'">{{ row.item.type }}</b-badge>
                                        </div>
                                    </template>

                                    <template #cell(offer_status)="row">
                                        <div>
                                            <b-badge variant="success" class="badge-pill" style="text-transform: capitalize;" v-if="row.item.offer_status == true">Active</b-badge>
                                            <b-badge variant="danger" class="badge-pill" style="text-transform: capitalize;" v-else>Inactive</b-badge>
                                        </div>
                                    </template>

                                    <template #cell(active)="row">
                                        <div>
                                            <b-badge variant="success" class="badge-pill" style="text-transform: capitalize;" v-if="row.item.active == true">Active</b-badge>
                                            <b-badge variant="danger" class="badge-pill" style="text-transform: capitalize;" v-else>Inactive</b-badge>
                                        </div>
                                    </template>

                                    <template #cell(created_on)="row">
                                        <div v-if="row.item.created_on" style="display: flex; flex-direction: column; gap: 4px;">
                                            <h7>{{ row.item.created_on.split('T')[0] }}</h7>
                                            <h7>{{ row.item.created_on.split('T')[1].split('.')[0] }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <!-- <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deletePackage(data.item.id)" title="Delete"></feather>
                                            </div> -->

                                            <div @click="editPackage(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Package Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Package" size="lg" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" v-model="package.title" placeholder="Enter title" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Coins</label>
                        <input class="form-control" type="number" v-model="package.coins" placeholder="Enter coins" />
                    </div>
                </div>
                <!-- <div class="col-sm-6">
                    <div class="form-group">
                        <label>Type</label>
                        <select class="form-control" v-model="package.type">
                            <option value="" disabled>Select a type</option>
                            <option value="monthly">Monthly</option>
                            <option value="yearly">Yearly</option>
                        </select>
                    </div>
                </div> -->
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Detail</label>
                        <input class="form-control" type="text" v-model="package.detail" placeholder="Enter short detail" />
                    </div>
                </div>
            </div>

            <div class="row">
                <!-- <div class="col-sm-6">
                    <div class="form-group">
                        <label>AI Enabled?</label>
                        <select class="form-control" v-model="package.ai_enabled">
                            <option :value="true">Yes</option>
                            <option :value="false">No</option>
                        </select>
                    </div>
                </div> -->
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Price</label>
                        <input class="form-control" type="number" v-model="package.price" placeholder="Enter price" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Offer Active?</label>
                        <select class="form-control" v-model="package.offer_status">
                            <option :value="true">Yes</option>
                            <option :value="false">No</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6" v-if="package.offer_status">
                    <div class="form-group">
                        <label>Offer Price</label>
                        <input class="form-control" type="number" v-model="package.offer_price" placeholder="Enter offer price" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Active?</label>
                        <select class="form-control" v-model="package.active">
                            <option :value="true">Yes</option>
                            <option :value="false">No</option>
                        </select>
                    </div>
                </div>
            </div>

            <!-- <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Number of Days</label>
                        <input class="form-control" type="number" v-model="package.number_of_days" placeholder="Enter duration" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Active?</label>
                        <select class="form-control" v-model="package.active">
                            <option :value="true">Yes</option>
                            <option :value="false">No</option>
                        </select>
                    </div>
                </div>
            </div> -->

            <!-- <div class="row"> 
                <div class="col-sm-12">
                    <label>Subscription Features</label>
                    <div v-for="(feature, index) in package.subscription_features" :key="index" class="form-group d-flex align-items-center mb-2" style="gap: 8px;">
                        <input class="form-control" type="text" v-model="feature.feature" placeholder="Enter feature name" />
                        <select class="form-control" v-model="feature.feature_icon">
                            <option value="fa-solid fa-check">✔️ Check (Available)</option>
                            <option value="fa-solid fa-x">❌ X (Not Available)</option>
                        </select>
                        <button type="button" class="btn btn-danger btn-sm" @click="removeFeature(index)">
                            ×
                        </button>
                    </div>
                    <button type="button" class="btn btn-secondary btn-sm mt-2" @click="addFeature">
                        + Add Feature
                    </button>
                </div>
            </div> -->
        </form>
    </b-modal>

    <!-- Package Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Package" size="lg" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" v-model="edit_package.title" placeholder="Enter title" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Coins</label>
                        <input class="form-control" type="number" v-model="edit_package.coins" placeholder="Enter coins" />
                    </div>
                </div>
                <!-- <div class="col-sm-6">
                    <div class="form-group">
                        <label>Type</label>
                        <select class="form-control" v-model="edit_package.type">
                            <option value="" disabled>Select a type</option>
                            <option value="monthly">Monthly</option>
                            <option value="yearly">Yearly</option>
                        </select>
                    </div>
                </div> -->
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Detail</label>
                        <input class="form-control" type="text" v-model="edit_package.detail" placeholder="Enter short detail" />
                    </div>
                </div>
            </div>

            <div class="row">
                <!-- <div class="col-sm-6">
                    <div class="form-group">
                        <label>AI Enabled?</label>
                        <select class="form-control" v-model="edit_package.ai_enabled">
                            <option :value="true">Yes</option>
                            <option :value="false">No</option>
                        </select>
                    </div>
                </div> -->
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Price</label>
                        <input class="form-control" type="number" v-model="edit_package.price" placeholder="Enter price" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Offer Active?</label>
                        <select class="form-control" v-model="edit_package.offer_status">
                            <option :value="true">Yes</option>
                            <option :value="false">No</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6" v-if="edit_package.offer_status">
                    <div class="form-group">
                        <label>Offer Price</label>
                        <input class="form-control" type="number" v-model="edit_package.offer_price" placeholder="Enter offer price" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Active?</label>
                        <select class="form-control" v-model="edit_package.active">
                            <option :value="true">Yes</option>
                            <option :value="false">No</option>
                        </select>
                    </div>
                </div>
            </div>

            <!-- <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Number of Days</label>
                        <input class="form-control" type="number" v-model="edit_package.number_of_days" placeholder="Enter duration" />
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Active?</label>
                        <select class="form-control" v-model="edit_package.active">
                            <option :value="true">Yes</option>
                            <option :value="false">No</option>
                        </select>
                    </div>
                </div>
            </div> -->

            <!-- <div class="row">
                <div class="col-sm-12">
                    <label>Subscription Features</label>
                    <div v-for="(feature, index) in edit_package.subscription_features" :key="index" class="form-group d-flex align-items-center mb-2" style="gap: 8px;">
                        <input class="form-control" type="text" v-model="feature.feature" placeholder="Enter feature name" />
                        <select class="form-control" v-model="feature.feature_icon">
                            <option value="fa-solid fa-check">✔️ Check (Available)</option>
                            <option value="fa-solid fa-x">❌ X (Not Available)</option>
                        </select>
                        <button type="button" class="btn btn-danger btn-sm" @click="removeEditFeature(index)">
                            ×
                        </button>
                    </div>
                    <button type="button" class="btn btn-secondary btn-sm mt-2" @click="addEditFeature">
                        + Add Feature
                    </button>
                </div>
            </div> -->
        </form>
    </b-modal>

    <!-- Package Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this package?</div>
    </b-modal>
</div>
</template>

<script>
import { mapState } from 'vuex';
import { myHost } from '../../../../_helpers/host';
import loader from '../../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host,
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'coins',
                    label: 'Coins',
                    sortable: true
                },
                {
                    key: 'price',
                    label: 'Price',
                    sortable: true
                },
                {
                    key: 'offer_price',
                    label: 'Offer Price',
                    sortable: true
                },
                // {
                //     key: 'number_of_days',
                //     label: 'Number of Days',
                //     sortable: true
                // },
                {
                    key: 'offer_status',
                    label: 'Offer Status',
                    sortable: true
                },
                {
                    key: 'active',
                    label: 'Active',
                    sortable: true
                },
                {
                    key: 'created_on',
                    label: 'Created On',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            package: {
                title: '',
                detail: '',
                price: 0,
                coins: 0,
                offer_price: 0,
                // number_of_days: 0,
                offer_status: false,
                active: false,
                ai_enabled: true,
                // subscription_features: [{
                //     feature: '',
                //     feature_icon: ''
                // }]
            },

            edit_package: {
                id: '',
                title: '',
                detail: '',
                price: 0,
                coins: 0,
                offer_price: 0,
                // number_of_days: 0,
                offer_status: false,
                active: false,
                ai_enabled: true,
                // subscription_features: [{
                //     feature: '',
                //     feature_icon: ''
                // }]
            },

            delete_value: null,

            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 15, 20]
        };
    },

    computed: {
        ...mapState({
            package_list: state => state.packages.package,
            loading: state => state.packages.packageLoading,
            error: state => state.packages.packageError
        }),

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
            .filter(f => f.sortable)
            .map(f => {
                return {
                    text: f.label,
                    value: f.key
                };
            });
        }
    },

    mounted() {
        this.$store.dispatch("packages/fetchPackage").then(() => {
            this.items = this.package_list
            this.totalRows = this.package_list.length;
        });
    },

    methods: {
        addFeature() {
            this.package.subscription_features.push({
                feature: '',
                feature_icon: ''
            });
        },

        removeFeature(index) {
            this.package.subscription_features.splice(index, 1);
        },

        addEditFeature() {
            this.edit_package.subscription_features.push({
                feature: '',
                feature_icon: ''
            });
        },

        removeEditFeature(index) {
            this.edit_package.subscription_features.splice(index, 1);
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.package = {
                title: '',
                detail: '',
                price: null,
                coins: null,
                offer_status: false,
                active: false,
                offer_price: null,
                // number_of_days: null,
                ai_enabled: true,
                // subscription_features: [{
                //     feature: '',
                //     feature_icon: 'fa-solid fa-check'
                // }]
            };
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("packages/addPackage", {
                package: this.package
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editPackage(detail) {
            this.edit_package = {
                id: detail.id || null,
                title: detail.title || '',
                detail: detail.detail || '',
                coins: detail.coins || 0,
                price: detail.price || null,
                offer_status: detail.offer_status !== undefined ? detail.offer_status : false,
                active: detail.active !== undefined ? detail.active : false,
                offer_price: detail.offer_price || null,
                // number_of_days: detail.number_of_days || null,
                // subscription_features: Array.isArray(detail.subscription_features) && detail.subscription_features.length ?
                // detail.subscription_features.map(f => {
                //     return {
                //         feature: f.feature || '',
                //         feature_icon: f.feature_icon || 'fa-solid fa-check'
                //     };
                // }) :
                // [{
                //     feature: '',
                //     feature_icon: 'fa-solid fa-check'
                // }]
            };
        },

        resetEditModal() {
            this.edit_package = {
                title: '',
                detail: '',
                price: null,
                coins: null,
                offer_status: false,
                active: false,
                offer_price: null,
                // number_of_days: null,
                ai_enabled: true,
                // subscription_features: [{
                //     feature: '',
                //     feature_icon: 'fa-solid fa-check'
                // }]
            };
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.$store.dispatch("packages/updatePackage", {
                id: this.edit_package.id,
                package: this.edit_package
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetEditModal();
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        // deletePackage(id) {
        //     this.delete_value = id
        // },

        // handleDeleteOk() {
        //     this.$store.dispatch("packages/deletePackage", {
        //         delete: this.delete_value
        //     }).then(response => {
        //         if (response.code == 200) {
        //             Swal.fire({
        //                 title: "Success!",
        //                 text: response.response,
        //                 icon: "success"
        //             });
        //             this.delete_value = null
        //         } else {
        //             Swal.fire({
        //                 title: "Error!",
        //                 text: response.response,
        //                 icon: "error"
        //             });
        //         }
        //     })
        // }
    }
};
</script>
